/**
 * @generated SignedSource<<87a0e8f916357f514a27b2de543bd5af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilesScreenComponentQuery$variables = Record<PropertyKey, never>;
export type FilesScreenComponentQuery$data = {
  readonly store: {
    readonly id: string;
    readonly integrationFlyers: ReadonlyArray<{
      readonly eMaginId: string | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"EmaginItem_IntegrationEmaginFlyer">;
    }> | null;
    readonly recentlyUploadedFiles: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SuggestionItem_File">;
    }>;
    readonly suggestedFiles: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SuggestionItem_File">;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"usePermissions_store">;
  };
};
export type FilesScreenComponentQuery = {
  response: FilesScreenComponentQuery$data;
  variables: FilesScreenComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eMaginId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "SuggestionItem_File"
},
v4 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "pdfUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorReason",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOrg",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "thumbnail",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "thumbhash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ImageSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlExpiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "height",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "width",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FilesScreenComponentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "usePermissions_store"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEmaginFlyer",
            "kind": "LinkedField",
            "name": "integrationFlyers",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EmaginItem_IntegrationEmaginFlyer"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "suggestedFiles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": "suggestedFiles(first:6)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "recentlyUploadedFiles",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FilesScreenComponentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myPermissions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEmaginFlyer",
            "kind": "LinkedField",
            "name": "integrationFlyers",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrls",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "suggestedFiles",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": "suggestedFiles(first:6)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "recentlyUploadedFiles",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "974f9e019c883e4e77d22852b48c633f",
    "id": null,
    "metadata": {},
    "name": "FilesScreenComponentQuery",
    "operationKind": "query",
    "text": "query FilesScreenComponentQuery {\n  store {\n    id\n    ...usePermissions_store\n    integrationFlyers {\n      id\n      eMaginId\n      ...EmaginItem_IntegrationEmaginFlyer\n    }\n    suggestedFiles(first: 6) {\n      ...SuggestionItem_File\n      id\n    }\n    recentlyUploadedFiles {\n      id\n      ...SuggestionItem_File\n    }\n  }\n}\n\nfragment EmaginItem_IntegrationEmaginFlyer on IntegrationEmaginFlyer {\n  id\n  eMaginId\n  title\n  imageUrls\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FileThumbnail_file on File {\n  type\n  status\n  isOrg\n  ...FileIcon_File\n  thumbnail {\n    id\n    ...Image_image\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment SuggestionItemStatusDetail_File on File {\n  status\n  errorReason\n}\n\nfragment SuggestionItem_File on File {\n  id\n  name\n  type\n  pdfUrl\n  status\n  ...SuggestionItemStatusDetail_File\n  ...FileThumbnail_file\n}\n\nfragment usePermissions_store on Store {\n  id\n  myPermissions\n}\n"
  }
};
})();

(node as any).hash = "418d8a7455b0f19359e081f68b61c4b2";

export default node;
